import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  loading: false,
  countStats: {
    products: 0,
    turnover: 0,
    salesCount: 0,
    customerCount: 0
  },
  dataStats: {
    sales: [],
    categories: [],
    productMostSalesNumber: [],
    productMostSalesAmount: [],
    sales_by_employee: [],
    sales_by_period: []
  },
  categoryStats: {
    total_categories: 0,
    sales_by_category: [],
    sales_count_by_category: []
  },
  customerStats: {
    total_contacts: 0,
    total_customers: 0,
    average_purchase_amount: 0,
    customer_visits: 0,
    customer_frequency: [],
    sales_count_by_category: []
  },
  saleStats: {
    average_sales: 0,
    sales_by_period: [],
    top_products: [],
    sales_by_employee: [],
    sales_by_hour: [],
    sales_by_shop: []
  },
  advancedCountStats: {
    contacts: 0,
    contactTotal: 0,
    products: 0,
    productTotal: 0,
    turnover: 0,
    turnoverTotal: 0
  },
  bestDayStats: {
    sales_by_period: []
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
}
